/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewladderstep3detail4Inputs */

const en_letterpreviewladderstep3detail4 = /** @type {(inputs: Letterpreviewladderstep3detail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enforceable remedy`)
};

const pt_letterpreviewladderstep3detail4 = /** @type {(inputs: Letterpreviewladderstep3detail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solução com força executiva`)
};

/**
* | output |
* | --- |
* | "Enforceable remedy" |
*
* @param {Letterpreviewladderstep3detail4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewladderstep3detail4 = /** @type {((inputs?: Letterpreviewladderstep3detail4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewladderstep3detail4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewladderstep3detail4(inputs)
	return pt_letterpreviewladderstep3detail4(inputs)
});
export { letterpreviewladderstep3detail4 as "letterPreviewLadderStep3Detail" }